import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {SavedQueriesService} from '../../../favorites/savedQueries/savedQueries.service';
import {SmoothScrollUtil} from '../../../nddUtils/smoothScrollUtil.service';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {Cheetah} from "../../cheetah.service";
import {MediaQueries} from "../../../infra/mediaQueries.service";

const flatten= require('lodash/flatten');
const _get = require('lodash/get');
@Component({
    'selector': 'prm-add-alert-toast', 
    templateUrl: 'components/search/savedQueries/addAlertToast/add-alert-toast.html'
})

export class PrmAddAlertToast implements OnInit{
    @Input() public userEmail  : string;
    @Input() public id  : number | Array<number>;
    @Input() public addMode  : string;

    private email:string;

    constructor(@Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
                @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                private savedQueriesService:SavedQueriesService,
                private smoothScrollUtil:SmoothScrollUtil,
                private configurationUtil: ConfigurationUtil,
                private cheetahService: Cheetah,
                private mediaQueries: MediaQueries) {
    }
    ngOnInit(){
        let currIds = flatten([this.id]);
        if (this.addMode) {
        	if(this.userEmail == 'undefined' ){
        		this.email = '';
        	}
        	else{
                this.email = this.userEmail;
        	}
        } else {
            this.email = this.userEmail? this.userEmail : this.savedQueriesService.Items.filter((item)=>{return (item.ID === currIds[0]);})[0].email;
        }

    }

    private openMoreInfo(target){
        let templateString = '<md-dialog aria-label="" style="display:initial;max-width: 380px;"><md-dialog-content><prm-edit-notification-settings [id]="ctrl.selectedIds" [email]="ctrl.email"[add-mode]="ctrl.addMode"></prm-edit-notification-settings></md-dialog-content></md-dialog>';
        let currIds = flatten([this.id]);
        let email= this.email;
        let addMode= this.addMode;
        let smoothScrollUtil= this.smoothScrollUtil;
        this.$mdDialog.show({
            controllerAs:'ctrl',
            controller: function(){
                this.selectedIds= currIds;
                this.email= email;
                this.addMode= addMode;
            },
            template: templateString,
            parent: angular.element(document.body),
            focusOnOpen: false,
            clickOutsideToClose: true,
            onComplete: function () {
                smoothScrollUtil.focusOn('input-mail-saved-searches');
            }
        });
    }




    private onDismiss() {
        this.$mdToast.hide();

    }


    public detectMobile(){
        if( this.mediaQueries.xs || this.mediaQueries.sm){
            return true;
        }
        return false;
    }


    public displayAlertForm(){
        if(this.configurationUtil.isSuprima()){
            let scopeId = this.cheetahService.searchData['scope'];
            let scopesObj = this.configurationUtil.getScopesObj(scopeId);
            let locations = _get(scopesObj,'[0].locations');
            if(locations ){
                let locationsArr = locations.split(',');
                if(locationsArr.includes('EbscoLocal') || locationsArr.includes('WorldCatLocal')){
                    return false;
                }
            }
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/savedQueries/addAlertToast/addAlertToast.directive.ts